import { render, staticRenderFns } from "./management-rule-group.component.vue?vue&type=template&id=8a56b130&scoped=true&"
import script from "./management-rule-group.component.vue?vue&type=script&lang=ts&"
export * from "./management-rule-group.component.vue?vue&type=script&lang=ts&"
import style0 from "./management-rule-group.component.vue?vue&type=style&index=0&id=8a56b130&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a56b130",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
installComponents(component, {VDivider})
